<template>
  <list-select :emit-only-value="false" ref="select" async :parse-callback="parse" v-on:input="(v) => $emit('input', v)" :search-data="search" v-model="model" />
</template>

<script>
import ListSelect from "@/reuse/input/ListSelect"
import {listTiposNotificacao} from "@/domain/cadastro/services/tiposNotificacao"
export default {
  name: "TipoNotificacaoSelect",
  props: {
    value: {
      required: true
    }
  },
  data () {
    return {
      model: this.value,
      result: []
    }
  },
  watch: {
    value (v) {
      this.$nextTick(() => {
        if (v !== this.model) {
          this.$refs.select.autoSelectValue(v)
        }
      })
    }
  },
  components: {ListSelect},
  methods: {
    parse (v) {
      return v && v.nome
    },
    search (terms) {
      console.log('Find', this.model)
      return new Promise((resolve, reject) => {
        listTiposNotificacao(100, 1, '').then(response => {
              this.result = response.data
              if (!response.data || !response.data.result.length) {
                resolve([])
              }
              let list = response.data.result.map((obj) => {
                return {
                  ...obj,
                  value: obj.id,
                  label: obj.nome
                }
              }).sort((a, b) => {
                if (a.nome > b.nome) {
                  return 1;
                }
                if (a.nome < b.nome) {
                  return -1;
                }
                // a must be equal to b
                return 0;
              })
              resolve(list)
            })
            .catch(({response}) => {
              reject(response)
            })
      })
    }
  }
}
</script>
